import PropTypes from 'prop-types';

export const EnergeticsDetailDefaultProps = {
  energyClasses: [],
  links: [],
};

export const EnergeticsDetailPropTypes = {
  energyClasses: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      score: PropTypes.string,
    }),
  ),
  links: PropTypes.arrayOf(PropTypes.string),
};
